/** Biz 枚举 */
export enum BizKind {
  /** 目前只做心跳用 */
  System = 'system',
  /** 只用作聊天相关 */
  Chat = 'chat',
  /** 用作用户通知 */
  Notice = 'notice',
}

/** Event 枚举-客户端上报 */
export enum UpEvent {
  /** 心跳 */
  Heartbeat = 'heartbeat',
  /** 加入聊天室 */
  OrderChatJoin = 'order_chat_join',
  /** 离开聊天室 */
  OrderChatLeave = 'order_chat_leave',
  /** 发送消息 */
  MsgSend = 'msg_send',
  /** 消息标记已读 */
  MsgRead = 'msg_read',
}

/** Event 枚举-服务下发 */
export enum DownEvent {
  SystemError = 'system_error',
  /** 心跳-回执 */
  HeartbeatAck = 'heartbeat_ack',
  /** 加入聊天室-回执 */
  OrderChatJoinAck = 'order_chat_join_ack',
  /** 发送消息-回执 */
  MsgSendAck = 'msg_send_ack',
  /** 收到新消息 */
  MsgPush = 'msg_push',
  /** 其他用户已读 */
  MsgReadPush = 'msg_read_push',
  /** 聊天室成员在线状态更新 */
  PeerOnlinePush = 'peer_online_push',
  /** 订单状态变更 */
  OrderStatusChanged = 'notify_order_status_updated',
  /** 订单悬浮通知更新 */
  NotifyPopup = 'notify_popup',
  /** 订单首页中间通知更新 */
  NotifyMiddle = 'notify_middle',
  /** 聊天室订单状态更新 */
  ChatOrderStatusUpdate = 'chat_order_status_update',
  /** 站内信(个人/广播) */
  Notify = 'notify',
  /** 悬浮通知已读（服务端批量移除） */
  NotifyPopupRead = 'notify_popup_read',
  /** 弹窗通知（如大转盘抽奖机会） */
  NotifyModal = 'notify_modal',
}

/** 弹窗通知类型 */
export enum NotifyModalKind {
  /** 大转盘抽奖机会 */
  LuckyWheels = 'lucky-wheels',
}

/** Code 枚举 */
export enum Code {
  /** 成功 */
  Success = 0,
  /** 参数非法 */
  InvalidParameter = 1,
  /** 服务内部错误 */
  InternalError = 2,
  /** 权限不足 */
  PermissionDenied = 10,
  /** 空消息 */
  ContentEmpty = 101,
  /** 文字太长 */
  TextTooLong = 102,
  /** 消息文字非法 */
  TextMalformed = 103,
  /** 消息太长 */
  BlocksLimit = 104,
  /** 图片格式非法 */
  ImageFormatErr = 205,
  /** 消息发送太频繁 */
  RateLimited = 401,
}

/** 订单通知类型 */
export enum OrderNotifyKind {
  /** 卖家确认提醒 */
  OrderToConfirm = 'order_to_confirm',
  /** 买家转账提醒 */
  OrderToTransfer = 'order_to_transfer',
  /** 卖家发货提醒 */
  OrderToDeliver = 'order_to_deliver',
  /** 订单状态变更提醒 */
  OrderStatusChanged = 'order_status_changed',
}

/** 通知已读类型 */
export enum NotifyAckKind {
  /** 悬浮框、首页中间通知-已读 */
  Overlay = 1,
  /** 通知中心-交易通知-已读，只需传"kind"，目前请求一次全部已读 */
  Center_Trade = 2,
  /** 通知中心-系统通知-已读，只需传"kind"，目前请求一次全部已读 */
  Center_System = 3,
  /** 通知中心-全部已读 */
  CenterAll = 4,
  /** 订单中心-已读 */
  OrderTab = 5,
}
